import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const styles = () => ({
  input: {
    width: 'calc(100% - 50px)',
    margin: '5px 25px 25px 25px',
  },
});

const DialogFileName = ({ classes, onChange, value }) => (
    <TextField
      autoFocus
      className={classes.input}
      id="name-simple"
      label="filename"
      value={value}
      onChange={e => onChange(e.target.value)}
    />
);

DialogFileName.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(DialogFileName);
